import { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiDialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';

export interface DialogProps
  extends Omit<MuiDialogProps, 'title' | 'children'> {
  title: ReactNode;
  center?: boolean;
  closeLabel?: string;
  footer?: ReactNode | ((handleClose: () => void) => ReactNode);
  children?: ReactNode | ((handleClose: () => void) => ReactNode);
  handleClose?: () => void;
}

const Dialog = ({
  title,
  center,
  footer,
  children,
  closeLabel,
  handleClose = () => {},
  ...rest
}: DialogProps) => {
  return (
    <MuiDialog
      onClose={handleClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      {...rest}
    >
      <Box
        className="dialog-header"
        sx={{
          py: 1,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: center ? 'center' : 'space-between',
          bgcolor: 'primary.main',
        }}
      >
        <Typography
          variant="h6"
          color="common.white"
          {...(center && { textAlign: 'center' })}
        >
          {title}
        </Typography>

        {!center && (
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      {typeof children === 'function' ? children(handleClose) : children}

      {typeof footer === 'function'
        ? footer(handleClose)
        : footer === null
        ? null
        : footer || (
            <Box
              className="dialog-footer"
              sx={{
                p: 2,
                columnGap: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button variant="contained" onClick={handleClose}>
                {closeLabel || 'Close'}
              </Button>
            </Box>
          )}
    </MuiDialog>
  );
};

export default Dialog;
